<template>
  <div v-if="items" class="vertical-list-container">
    <div v-for="(item, index) in items" :key="index" class="vertical-list-item-wrapper">
      <div
           class="vertical-list-card"
           @click="handleClick(item,index)">
        <span class="vertical-list-title">{{ item.title }}</span>
      </div>
    </div>
  </div>
  <div v-else>
    <div style="text-align: center;margin: 16px">【无数据】</div>
  </div>
</template>

<script>
export default {
  name: 'GridText',
  props: {
    // 传入数组
    itemArray: {
      type: Array,
      default: () => []
    },
    // 宫格列数
    columnNum: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      items: null
    }
  },
  mounted () {
    if (this.itemArray.length === 0) {
      return
    }
    this.items = this.itemArray
    // for (const itemsKey in this.items) {
    //   this.items[itemsKey].fake = false
    // }
    // // 计算数组最后一行缺少的个数
    // const lastRowLackNum = this.columnNum - this.itemArray.length % this.columnNum
    // console.log('缺少', lastRowLackNum)
    // // 补充缺少的个数
    // for (let i = 0; i < lastRowLackNum; i++) {
    //   this.items.push({ fake: true })
    // }
  },
  methods: {
    handleClick (item, index) {
      this.$emit('click', item, index)
    }
  }
}
</script>

<style scoped>
.vertical-list-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vertical-list-item-wrapper {
  width: 100%;
  display: flex;
}

.vertical-list-card {
  width: 100%;
  background: #fff;
  color: #0a4b3d;
  font-size: 17px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(12,79,168,0.06);
  border: 1.5px solid #eaf7ff;
  display: flex;
  align-items: center;
  padding: 8px 18px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
  user-select: none;
  position: relative;
  overflow: hidden;
  word-break: break-all;
}
.vertical-list-card:hover {
  background: #eaf7ff;
  color: #0c4fa8;
  box-shadow: 0 4px 16px 0 rgba(12,79,168,0.10);
}
.vertical-list-card:active {
  background: #d0eaff;
  color: #063366;
  box-shadow: 0 2px 8px 0 rgba(12,79,168,0.18);
}
.vertical-list-title {
  flex: 1;
  font-size: 17px;
  font-weight: 600;
  text-align: left;
  line-height: 1.5;
  letter-spacing: 0.5px;
  word-break: break-all;
}
.vertical-list-card-empty {
  background: transparent;
  border: none;
  box-shadow: none;
  cursor: default;
}
</style>
